<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<!-- <app-warning-label></app-warning-label> -->
<div class="ui label warning-label">
  <span>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
        stroke="#2C6ECB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>

  <div class="text">
    <span>Please note:</span>
    Any changes made here will be verified before it appears on your profile
  </div>
</div>

<div class="content">
  <div
    class="scroll-wrapper ui basic segment"
    appPadding="0"
    [ngClass]="{ loading: pending }"
  >
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>

    <div class="ui form" [formGroup]="otherTCCForm">
      <div class="required field" [ngClass]="displayFieldCss('tccNumber')">
        <label>Enter your TCC ID/NO</label>
        <input
          #input
          formControlName="tccNumber"
          type="text"
          placeholder="Enter TCC ID/NO"
        />
        <app-field-error-display
          [displayError]="isFieldValid('tccNumber')"
          errorMsg="Please enter your TCC ID/NO"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('tccIssueDate')">
        <label>Enter Issued Date</label>
        <input
          suiDatepicker
          [pickerMode]="mode"
          placeholder="Enter your Issued Date"
          type="text"
          formControlName="tccIssueDate"
        />
        <app-field-error-display
          [displayError]="isFieldValid('tccIssueDate')"
          errorMsg="Please enter your issued date"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('tccExpiryDate')">
        <label>Enter Expiry Date</label>
        <input
          suiDatepicker
          [pickerMode]="mode"
          placeholder="Enter Expiry Date"
          type="text"
          formControlName="tccExpiryDate"
        />
        <app-field-error-display
          [displayError]="isFieldValid('tccExpiryDate')"
          errorMsg="Please enter your Expiry Date"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('taxOfficeName')">
        <label>Enter Tax Office Name</label>
        <input
          #input
          formControlName="taxOfficeName"
          type="text"
          placeholder="Enter Tax Office Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('taxOfficeName')"
          errorMsg="Please enter  your tax office name"
        >
        </app-field-error-display>
      </div>

      <div
        class="required field"
        [ngClass]="displayFieldCss('taxOfficeAddress')"
      >
        <label>Enter Tax Office Address</label>
        <input
          #input
          formControlName="taxOfficeAddress"
          type="text"
          placeholder="enter Tax Office Address"
        />
        <app-field-error-display
          [displayError]="isFieldValid('taxOfficeAddress')"
          errorMsg="Please enter  your tax office address"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('year')">
        <label>Enter Year</label>
        <input
          suiDatepicker
          [pickerMode]="'year'"
          placeholder="Enter year"
          type="text"
          formControlName="year"
        />
        <app-field-error-display
          [displayError]="isFieldValid('year')"
          errorMsg="Please enter  year"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('totalProfit')">
        <label>Total Profit</label>
        <input
          #input
          formControlName="totalProfit"
          type="text"
          placeholder="Enter total profit"
        />
        <app-field-error-display
          [displayError]="isFieldValid('totalProfit')"
          errorMsg="Please enter  total profit"
        >
        </app-field-error-display>
      </div>

      <div
        class="required field"
        [ngClass]="displayFieldCss('assessableProfit')"
      >
        <label>Accessible Profit</label>
        <input
          #input
          formControlName="assessableProfit"
          type="text"
          placeholder="Enter Accessible Profit"
        />
        <app-field-error-display
          [displayError]="isFieldValid('assessableProfit')"
          errorMsg="Please enter  Accessible Profit"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('turnOver')">
        <label>Turnover</label>
        <input
          #input
          formControlName="turnOver"
          type="text"
          placeholder="Enter your turnover"
        />
        <app-field-error-display
          [displayError]="isFieldValid('turnOver')"
          errorMsg="Please enter  your turnover"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('taxPaid')">
        <label>Tax Paid</label>
        <input
          #input
          formControlName="taxPaid"
          type="text"
          placeholder="Enter tax paid"
        />
        <app-field-error-display
          [displayError]="isFieldValid('taxPaid')"
          errorMsg="Please enter  your tax paid"
        >
        </app-field-error-display>
      </div>

      <div appMargin marginB="7"></div>
    </div>

    <form
      class="ui form"
      appMargin
      style="margin-bottom: 30px; flex-direction: column; margin-top: 30px"
      *ngIf="uploads.length > 0"
    >
      <h2 class="ui head" fxFlex="auto">Upload Supporting Document</h2>
      <p>
        Click the plus (+) button to upload new document. You can link any
        similar document you have uploaded before now by choosing the Link
        option. Only .pdf, .doc and .ppt files can be uploaded
      </p>
      <div>
        <div
          *ngFor="let document of documentss; let i = index"
          style="margin-bottom: 20px"
        >
          <div
            fxLayout="row"
            style="width: 100%; align-items: center !important"
          >
            <label fxFlex="auto" [ngClass]="{ required: document.isRequired }">
              Upload {{ document.documentTypeName }}
            </label>
            <div suiDropdown>
              <button
                class="ui tiny icon button"
                style="border: none !important; align-items: center !important"
                style="float: right"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="cursor: pointer; outline: none"
                  suiPopup
                  [popupInverted]="true"
                  popupPlacement="bottom"
                  popupText="upload Document"
                >
                  <path
                    d="M8 3V13M3 8H13"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <div
                class="menu"
                style="
                  height: 80px;
                  margin-top: 40px;
                  position: absolute;
                  width: 100px;
                  right: 0px;
                  width: fit-content;
                  z-index: 1000;
                "
                suiDropdownMenu
                appPadding
                paddingX="3"
              >
                <div
                  class="item"
                  style="
                    font-family: 'Roboto';
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 14.06px;
                    text-align: left;
                    color: #505050;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    height: 40px;
                    cursor: pointer;
                  "
                  (click)="uploader.click()"
                >
                  <input
                    #uploadDoc
                    type="file"
                    accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
                    #uploader
                    multiple
                    (change)="onFileChanges($event, document)"
                    placeholder="Browse for documents"
                    onclick="value = null"
                    style="display: none"
                  />
                  Upload new document
                </div>
                <a
                  class="item"
                  style="
                    font-family: 'Roboto';
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 14.06px;
                    text-align: left;
                    color: #505050;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    height: 40px;
                    cursor: pointer;
                  "
                  (click)="LinkDocument(document.documentTypeName)"
                  >Link an existing document</a
                >
              </div>
            </div>
          </div>
          <div
            style="width: 100%"
            class="ui divider"
            appMargin
            marginT="1"
          ></div>
          <div
            *ngIf="
              returnDocumentType(allLinkedDocuments, document.documentTypeName)
                .length > 0
            "
            style="width: 100%"
            class="field"
            appMargin
            marginT="5px"
          >
            <div
              class="item"
              style="
                padding: 16px 0px;
                color: #3f4395;
                font-size: 14px;
                font-weight: 500;
              "
            >
              Linked existing documents of {{ document.documentTypeName }}
            </div>
            <ng-container class="document">
              <div
                *ngFor="
                  let doc of returnDocumentType(
                    allLinkedDocuments,
                    document.documentTypeName
                  );
                  let i = index
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 64px;
                    border-top: 1px solid #dfdfdf;
                    width: 100%;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <img
                      src="../../../../../assets/icons/pdfdoc.svg"
                      alt="data"
                    />
                    <p
                      style="
                        margin-left: 20px;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 16px;
                        color: #505050;
                      "
                    >
                      {{ doc.documentName }}
                    </p>
                  </div>
                  <div>
                    <div
                      style="
                        align-items: center !important;
                        gap: 8px;
                        display: flex;
                        justify-content: flex-end;
                      "
                    >
                      <a
                        href="{{ baseUrl }}/public/media/?media={{
                          doc.documentPath
                        }}"
                        target="_blank"
                      >
                        <i class="eye icon"></i>
                      </a>
                      <div
                        class="ui button"
                        style="background-color: #eaeffb; border-radius: 8px"
                        (click)="
                          editLinkedDocument(doc, i, document.documentTypeName)
                        "
                      >
                        Edit
                      </div>
                      <img
                        class="hoverable"
                        src="assets/icons/cancel.svg"
                        (click)="removeLinkedDocument(doc, i)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <div style="width: 100%" class="field" appMargin marginT="5px">
            <ng-container
              *ngIf="
                document.uploadedFiles && document.uploadedFiles.length > 0
              "
            >
              <ng-container
                *ngFor="
                  let file of document.uploadedFiles;
                  let fileIndex = index
                "
              >
                <div
                  fxLayout="row"
                  fxLayoutGap="10px"
                  fxLayoutAlign="start center"
                  appMargin
                  marginB="15px"
                >
                  <div
                    fxFlex="grow"
                    class="ui segment"
                    style="border-radius: 8px"
                  >
                    <div
                      fxFlex="row"
                      fxLayoutGap="10px"
                      fxLayoutAlign="start center"
                    >
                      <div fxFlex="10">
                        <img
                          src="assets/icons/file-type/doc-upload.svg"
                          alt=""
                        />
                      </div>
                      <div fxFlex="75">
                        <div>
                          {{ file.name }}
                        </div>
                      </div>
                      <div fxFlex fxLayoutAlign="end">
                        <div
                          class="ui button"
                          style="background-color: #eaeffb; border-radius: 8px"
                          (click)="uploaderEdit.click()"
                        >
                          <input
                            #uploadDoc
                            type="file"
                            accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
                            #uploaderEdit
                            multiple
                            (change)="editFile($event, document, fileIndex)"
                            placeholder="Edit document"
                            onclick="value = null"
                            style="display: none"
                          />
                          Edit
                        </div>
                        <img
                          class="hoverable"
                          src="assets/icons/cancel.svg"
                          (click)="removeFile(document, fileIndex)"
                        />
                      </div>
                    </div>
                  </div>
                </div> </ng-container
            ></ng-container>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="actions" style="background: inherit; border: none">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending || !otherTCCForm.valid"
    (click)="updateDirector('UPDATE')"
    autofocus
  >
    Done
  </button>
</div>
